import { CustomFieldFormModel } from "../../models/customField.model";
import { itemSelection } from "../../models/itemSelection.model";
import AlertMessage from "../common/AlertMessage";
import InputLabel from "../common/InputLabel";
import SimpleSelection from "../common/SimpleSelection";
import './index.css'

interface CustomFieldFormProps {
  customFieldForm: CustomFieldFormModel
  customFieldTypeList: itemSelection[]
  handleChange?: (p: any) => void
  action?: string
  errors?: string[]
  editable?: boolean
}

const CustomFieldForm: React.FC<CustomFieldFormProps> = ({
  customFieldForm,
  customFieldTypeList,
  handleChange = () => { },
  action = 'view',
  errors = []
}) => {


  return <>
    <div className="projectsettings-action-form">
      <div className="projectsettings-action-form-item">
        <InputLabel
          label='Nombre'
          name='hname'
          value={customFieldForm.hname}
          disabled={action === 'view'}
          onChange={handleChange}
          required
          error={errors.includes('hname') && customFieldForm.hname.length === 0}
        />
      </div>

      {(action === 'view' || action === 'edit') && (<>

        <div className="projectsettings-action-form-item">
          <InputLabel
            label='Fecha de Creación'
            name='created_date'
            value={customFieldForm.created_date}
            disabled
            onChange={handleChange}
          />
        </div>
      </>)}

      <div className="projectsettings-action-form-item">
        <SimpleSelection
          label='Tipo'
          name='type'
          value={customFieldForm.type}
          options={customFieldTypeList}
          onChange={handleChange}
          disabled={action === 'view' || action === 'edit'}
        />
      </div>

      <div className="projectsettings-action-form-item">
        <InputLabel
          label='Valor por Defecto'
          name='default_value'
          value={customFieldForm.default_value}
          type={customFieldForm.type.type_name ?? 'string'}
          disabled={action === 'view'}
          onChange={handleChange}
        />
      </div>

    </div>
  </>
}

export default CustomFieldForm;